<script setup lang="ts">
import { ref } from 'vue'
import { FilterField, TableField } from "../../../../components/table/table";
import { Permission } from '../../../../types/auth'
import ListTemplate from "../../../../components/ui/common/ListTemplate.vue";
import ShiftEndReportsForm from './ShiftEndReportsForm.vue';
import { api } from '../../../../api/Api';
import Toast from '../../../../services/Toast';
import { printPDFBlob } from '../../../../utils/CommonFunctions';

withDefaults(defineProps<{
  showHeader?: boolean,
  showQuickTour?: boolean,
  showTitle?: boolean,
  showNextButton?: boolean
  permissions?: Permission[]
}>(), {
  showHeader: true,
  showQuickTour: true,
  showTitle: true
})

const endPoint = '/clients/finance/collections/shift-end-reports/'
const title = 'Shift End Reports'
const selectedData = ref<any | null>(null)
const showForm = ref(false)
const formMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'>('view')
const refreshData = ref(false)

const fields: TableField[] = [
  { name: 'date_time', caption: 'Date', sortable: true, fieldType: 'text' },
  { name: 'outlet', caption: 'Outlet', sortable: true, fieldType: 'text' },
  { name: 'outlet_pos_station', caption: 'POS Station', sortable: true, fieldType: 'text' },
  { name: 'user', caption: 'Cashier', sortable: true, fieldType: 'text' },
  { name: 'system', caption: 'System', sortable: true, fieldType: 'number', width: '150px' },
  { name: 'counted', caption: 'Actual', sortable: true, fieldType: 'number', width: '150px' },
  { name: 'difference', caption: 'Difference', sortable: true, fieldType: 'number', width: '150px' },
  { name: 'status', caption: 'Status', sortable: false, fieldType: 'text' },
]

const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
     options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
]

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleTableActions = async (action: string, data: any) => {
  if (action === 'thermal') {
    const response = await api.post(
    (endPoint.slice(-1) == "/" ? endPoint : endPoint + "/") + "print-thermal",
    {
      id: data.uid,
    }
  );
  if (response.success == true) {
    console.log(response.data)
    printPDFBlob(response.data)
  } else {
    Toast.show('Could not print Thermal Report', 'error')
  }
  } 
}
const handleData = (data : any) => {
  selectedData.value = data
}
</script>

<template>
  <ListTemplate :endPoint = "endPoint" :title = "title" :fields = "fields" :actions = "[
    { name: 'print', icon: 'Printer', title: 'Print A4', permission: 'view', visible:()=> true, variant: 'primary' },
    { name: 'thermal', icon: 'ReceiptText', title: 'Print Thermal', permission: 'edit', visible:()=> true, variant: 'primary' },
  ]" :filterFields ="filterFields" @custom="handleTableActions"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" :allow-disable="false"
  :allow-edit="false"
  @data="handleData" :show-header="showHeader" :show-quick-tour="showQuickTour" :show-title="showTitle" :show-next-button="showNextButton">
  <template #form-view>
    <ShiftEndReportsForm
      :permissions="permissions"
      v-if="showForm"
      :data="selectedData"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @save="refreshData = !refreshData"
      @close="showForm = !showForm"
    />
  </template>
  </ListTemplate>
</template>